import { Project } from 'core/models/project';
import { Vehicle } from 'core/models/vehicle';
import { TokenInfo } from 'infrastructure/t4/api/TokenKeeper';
import { useEffect, useState } from 'react';
import { useAuthTokenRepository } from './useAuthTokenRepository';
import { cancellable } from './utility/cancellable';

function useAuthToken() {
    const repos = useAuthTokenRepository();

    const [tokenInfo, setTokenInfo] = useState<TokenInfo>();

    useEffect(() => {
        const theRepos = repos;
        const listener = (token: string, expiresAt: Date) => {
            setTokenInfo({ token, expiresAt });
        };

        theRepos.addListener(listener);

        return () => theRepos.removeListener(listener);
    }, [repos]);

    return tokenInfo;
}

export function useEmergencyButtons(projectId: Project.Id, vehicleIds: Vehicle.Id[]) {
    const { token, expiresAt } = useAuthToken() ?? {};

    const [isReady, setReady] = useState(false);
    const [error, setError] = useState<unknown>();

    useEffect(() => {
        if (!token || !expiresAt) return;

        return cancellable(async isCanceled => {
            const expiresIn = (expiresAt.valueOf() - Date.now()) / 1000.0;
            try {
                await fetch('http://localhost:6543/session/token', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        expiresIn,
                        token,
                    }),
                });
                if (isCanceled()) return;
                setReady(true);
            } catch (e) {
                if (isCanceled()) return;
                setError(e);
            }
        });
    }, [token, expiresAt, setReady]);

    useEffect(() => {
        if (!isReady) return;

        fetch('http://localhost:6543/emergencyButtons/target', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                project: { id: projectId },
                vehicles: vehicleIds.map(id => ({ id })),
            }),
        });
    }, [isReady, projectId, vehicleIds]);

    return error;
}
